import { render, staticRenderFns } from "./LanguageFilter.vue?vue&type=template&id=4c191d1b&scoped=true&"
import script from "./LanguageFilter.vue?vue&type=script&lang=js&"
export * from "./LanguageFilter.vue?vue&type=script&lang=js&"
import style0 from "./LanguageFilter.vue?vue&type=style&index=0&id=4c191d1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c191d1b",
  null
  
)

export default component.exports